import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  search: {
    minWidth: 250,
    maxWidth: 360
  }
}))
